module.exports = __webpack_public_path__ + "img/category_13.27d69fea.png";